export function buildLoginRedirectUrl(redirectUrl?: string): string {
  const destination =
    redirectUrl ??
    `${window.location.origin}${window.location.pathname}${window.location.search}`;
  return `/_hcms/mem/login?redirect_url=${encodeURIComponent(destination)}`;
}

export function redirectToLogin(redirectUrl?: string): void {
  window.location.href = buildLoginRedirectUrl(redirectUrl);
}
